import { useCallback, useState } from 'react';
import { CalcTarget } from '../types';

/** De actuele berekening (afstand, pace, tijd) die alle schermen delen. */
export function useCalculator() {
  const [calcTarget, setCalcTarget] = useState<CalcTarget>('time');
  const [distanceKm, setDistanceKm] = useState<number>(10);
  const [paceSecsPerKm, setPaceSecsPerKm] = useState<number>(300); // 5:00 /km
  const [totalSeconds, setTotalSeconds] = useState<number>(3000); // 50:00

  const setAll = useCallback((dist: number, pace: number, time: number) => {
    setDistanceKm(dist);
    setPaceSecsPerKm(pace);
    setTotalSeconds(time);
  }, []);

  return {
    calcTarget, setCalcTarget,
    distanceKm, setDistanceKm,
    paceSecsPerKm, setPaceSecsPerKm,
    totalSeconds, setTotalSeconds,
    setAll,
  };
}
